module.exports = __webpack_public_path__ + "assets/2-Denver-Sales-Careers-Tech.bccf2fe1.png";